import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import classnames from 'classnames';
import LinesEllipsis from 'react-lines-ellipsis';
import { push } from "connected-react-router";
import { sortableHandle } from 'react-sortable-hoc';
import Tooltip from "../../../ui/Tooltip/Tooltip";

import "./QuestionItem.scss";

import {
  restoreQuestionAsync,
} from "../../../../redux/actions/questionsList";

const mapStateToProps = state => ({
  countForClients: state.ui.countForClients,
  countForConsultants: state.ui.countForConsultants,
});

const mapDispatchToProps = dispatch => ({
  onClickQuestion: questionId => dispatch(push(`/question/${questionId}`)),
  onRestoreQuestion: (status, questionId, questionIndex) => dispatch(restoreQuestionAsync(status, questionId, questionIndex)),
});

const DragHandle = sortableHandle(() => <div className="points" />);

class QuestionItem extends Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    onClickQuestion: PropTypes.func.isRequired,
    onRestoreQuestion: PropTypes.func.isRequired,
    //Количество уже созданных вопросов разных типов
    countForClients: PropTypes.number.isRequired,
    countForConsultants: PropTypes.number.isRequired,
  };

  constructor() {
    super();
    this.state = {
      showTooltip: false,
    }
  }

  onClickQuestionItem = (id, is_visible) => {
    const { onClickQuestion } = this.props;
    if (is_visible) onClickQuestion(id); 
  }

  //Тултип
  buttonMouseEnter = isDisabled => {
    if (isDisabled) this.setState({ showTooltip: true });
  }

  render() {
    const { question, onRestoreQuestion, countForClients, countForConsultants } = this.props;
    const { showTooltip } = this.state;

    const questionClass = classnames({
      'question-main': true,
      'closed': !question.is_visible,
    });

    //Вопрос нельзя восстановить, если уже есть 5 видимых вопросов такого же типа
    let isDisabled = false;
    if (!question.is_visible) {
      if (((question.role === 'client') && (countForClients >= 5)) 
        || ((question.role === 'consultant') && (countForConsultants >= 5))) isDisabled = true;
    }

    const tooltipText = "Максимум 5 активных вопросов для создания";

    return (
      <div className={questionClass}>
        <div className="main-wrap" onClick={() => this.onClickQuestionItem(question.id, question.is_visible)}>
          <LinesEllipsis
            text={question.header}
            maxLine='2'
            ellipsis='...'
            trimRight
            basedOn='letters'
            className="question-title"
          />
          {!question.is_visible ? (
            <div className="question-content closed">
              <div className="closed-text">Вопрос скрыт</div>
              <div
                className="black-btn-wrap"
                onMouseEnter={() => this.buttonMouseEnter(isDisabled)}
                onMouseLeave={() => { this.setState({ showTooltip: false }); }}
              >
                <Tooltip text={tooltipText} show={showTooltip} />
                <button
                  type="button"
                  className="btn btn-black"
                  disabled={isDisabled}
                  onClick={() => onRestoreQuestion(true, question.id, question.index)}
                >
                  Восстановить
                </button>
              </div>
            </div>
          ) : (
            <div className="question-content">
              <div className="question-for">
                {(question.role === 'consultant') ?
                  (<div className="for-item consultants">Консультанты</div>)
                : false}
                {(question.role === 'client') ?
                  (<div className="for-item clients">Клиенты</div>)
                : false}
              </div>
            </div>
          )}
        </div>
        { question.is_visible ? (<div className="handle-wrap"><DragHandle /></div>) : false }
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionItem);
